import type { ComponentType } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

/**
 * Eine Route, die an eine neue Adresse weiterreicht — Query und Hash
 * wandern mit, damit alte Lesezeichen und Mail-Links ankommen, wo sie
 * hinwollten. `replace`: die alte Adresse bleibt nicht im Verlauf stehen,
 * sonst fuehrt „Zurueck" in eine Weiterleitungs-Schleife.
 */
export function redirectTo(to: string): ComponentType {
  function Weiterleitung() {
    const { search, hash } = useLocation()
    return <Navigate to={`${to}${search}${hash}`} replace />
  }
  Weiterleitung.displayName = `Weiterleitung(${to})`
  return Weiterleitung
}
